import React from 'react';
import { 
  Grid, 
  TextField, 
  Box, 
  Button, 
  Radio, 
  RadioGroup, 
  FormControlLabel, 
  Typography 
} from '@mui/material';

const ApprovalForm = ({ apprDoc, formik }) => {
  return (
    <Box 
      component="form" 
      onSubmit={formik.handleSubmit} 
      noValidate 
      sx={{ 
       
        display: 'flex', 
        alignItems: 'center' 
      }}
    >
      {/* 상단 정보 텍스트 (주석 유지)
      <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>
        결재 타입: <b>{apprDoc?.docyTyp}</b> | 단계: <b>{apprDoc?.docuStep}</b> | 결재자: <b>{apprDoc?.docuUsrNm}{apprDoc?.docuUsrGradeNm}</b>
      </Typography>
      */}

      <Grid container alignItems="center" spacing={2} wrap="nowrap">
        {/* 1. 타이틀 */}
        <Grid item sx={{ whiteSpace: 'nowrap' }}>
          <Typography variant="subtitle1" sx={{fontWeight: 'bold', lineHeight: 1.2 }}>
            결재 확인
          </Typography>
        </Grid>

        {/* 2. 결재 여부 (라디오 버튼) */}
        <Grid item sx={{ whiteSpace: 'nowrap' }}>
          <RadioGroup 
            row 
            name="docuYn" 
            value={formik.values.docuYn || 'Y'} 
            onChange={(e) => formik.setFieldValue('docuYn', e.target.value)}
            sx={{ flexWrap: 'nowrap' }}
          >
            <FormControlLabel 
              value="Y" 
              control={<Radio size="small" sx={{ py: 0 }} />} 
              label={<Typography variant="body2">승인</Typography>} 
              sx={{ m: 0, mr: 1 }} 
            />
            <FormControlLabel 
              value="N" 
              control={<Radio size="small" sx={{ py: 0 }} />} 
              label={<Typography variant="body2">비승인</Typography>} 
              sx={{ m: 0 }} 
            />
          </RadioGroup>
        </Grid>

        {/* 3. 참고사항 입력 (라인 맞춤 최적화) */}
        <Grid item xs>
          <TextField 
            fullWidth 
            size="small" 
            variant="standard" 
            id="docuTxt" 
            name="docuTxt" 
            placeholder="참고사항을 입력하세요" 
            value={formik.values.docuTxt} 
            onChange={formik.handleChange} 
            error={formik.touched.docuTxt && Boolean(formik.errors.docuTxt)}
            InputProps={{ 
              sx: { 
                fontSize: '0.875rem', 
                height: '30px', // 버튼 높이와 일치
                '&:before': { borderBottom: '1px solid #ccc' } 
              } 
            }}
          />
        </Grid>

        {/* 4. 결재 버튼 */}
        <Grid item>
          <Button 
            type="submit" 
            color="secondary" 
            variant="contained" 
            size="small" 
            disabled={formik.isSubmitting} 
            sx={{ 
              minWidth: '70px', 
              height: '30px', 
              whiteSpace: 'nowrap',
              boxShadow: 'none',
              '&:hover': { boxShadow: 'none' }
            }}
          >
            결재
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ApprovalForm;
